import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import utilities from "./utilities/utility";
import fb from "./firebaseConfig.js";
import { firestorePlugin } from "vuefire";
import "./registerServiceWorker";
import vSelect from "vue-select";
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
// Init plugin
Vue.use(Loading);
Vue.component("v-select", vSelect);
Vue.use(require("vue-moment"));
Vue.use(firestorePlugin);
Vue.mixin(utilities.mixin());

Vue.config.productionTip = false;

let app;
fb.auth.onAuthStateChanged(async (user) => {
  if (user) {
    store.commit("setUser", user);
    await store.dispatch("setUserDoc", user.uid);
  }
  if (!app) {
    app = new Vue({
      store: store,
      router,
      store,
      render: (h) => h(App),
      created() { },
    }).$mount("#app");
  }
});
